import React, {useState} from 'react'
import Img from 'gatsby-image'
import {motion, AnimatePresence} from 'framer-motion'
import './Slideshow.scss'

const Slide = ({title, image, variants}) => {

	const captionVariants = {
		animate: {y: 0, opacity: 1},
		initial: {y: -50, opacity: 0},
		exit: {y: 50, opacity: 0}
	}

	return (
		<>
			<div className="Slide-wrapper">
				<motion.div
					className="Slide"
					variants={variants}
					animate="animate"
					exit="exit"
					initial="initial"
					transition={{
						duration: .6,
						ease: 'easeInOut'
					}}
				>
					{
						image !== null &&
						<Img fluid={image.childImageSharp.fluid} />
					}
				</motion.div>
			</div>
			<motion.div
				className="Caption grid"
				variants={captionVariants}
				animate="animate"
				exit="exit"
				initial="initial"
				transition={{
					duration: .3,
					ease: 'easeInOut'
				}}
			>
				<div className="inner">
					<p>{title}</p>
				</div>
			</motion.div>
		</>
	)
}

export default ({slides}) => {

	const [slideDirection, setSlideDirection] = useState('next')
	const [currentSlide, setCurrentSlide] = useState(0)

	const nextSlide = () => {
		setSlideDirection('next')
		setTimeout(() => {
			if(currentSlide < (slides.length - 1)) {
				let nextSlide = currentSlide + 1;
				setCurrentSlide(nextSlide)
			} else {
				setCurrentSlide(0)
			}
		}, 200)
	}

	const prevSlide = () => {
		setSlideDirection('prev')
		setTimeout(() => {
			if(currentSlide === 0) {
				setCurrentSlide(slides.length - 1)
			} else {
				let prevSlide = currentSlide - 1
				setCurrentSlide(prevSlide)
			}
		}, 200)
	}

	const variants = {
		next: {
			animate: { x: '0%' },
			exit: { x: '-100%' },
			initial: {x: '100%' }
		},
		prev: {
			animate: { x: '0%' },
			exit: { x: '100%' },
			initial: {x: '-100%' }
		}
	}

	return(
		<div className="Slideshow">
			<div className="navigation">
				<button className="next" onClick={nextSlide}>Next</button>
				<button className="prev" onClick={prevSlide}>Previous</button>
			</div>
			<AnimatePresence>
				{
					slides.map((slide, index) => {
						if(index === currentSlide) {
							return(<Slide key={index} {...slide} variants={variants[slideDirection]} />)
						}
						return null
					})
				}
			</AnimatePresence>
		</div>
	)
}